import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

const renderNumberCircleComponent = (params: {
  showTickIcon?: boolean,
  isActive: boolean,
  isComplete: boolean,
  stepNumber: number,
}) => {
  const {
    isActive, isComplete, showTickIcon = false, stepNumber,
  } = params

  if (showTickIcon){
    if (isComplete){
      return (
        <Box
          alignItems="center"
          backgroundColor="blue"
          border="1px solid"
          borderColor="blue"
          borderRadius="100%"
          color="white"
          fontSize="small"
          height={26}
          justifyContent="center"
          width={26}
        >
          <FontAwesomeIcon icon={faCheck} />
        </Box>
      )
    }

    return (
      <Box
        alignItems="center"
        backgroundColor={isActive ? 'blue' : undefined}
        border="1px solid"
        borderColor={isActive ? 'blue' : 'lineColor'}
        borderRadius="100%"
        color={isActive ? 'white' : 'lightGrey'}
        fontSize="small"
        height={26}
        justifyContent="center"
        width={26}
      >
        {stepNumber}
      </Box>
    )
  }

  if (isActive){
    return (
      <Box
        alignItems="center"
        backgroundColor="blue"
        border="1px solid"
        borderColor="blue"
        borderRadius="100%"
        color="white"
        fontSize="small"
        height={26}
        justifyContent="center"
        width={26}
      >
        {showTickIcon ? <FontAwesomeIcon icon={faCheck} /> : stepNumber}
      </Box>
    )
  }

  if (isComplete){
    return (
      <Box
        alignItems="center"
        backgroundColor="blue"
        border="1px solid"
        borderColor="blue"
        borderRadius="100%"
        color="white"
        fontSize="small"
        height={26}
        justifyContent="center"
        width={26}
      >
        <FontAwesomeIcon icon={faCheck} />
      </Box>
    )
  }

  return (
    <Box
      alignItems="center"
      border="1px solid"
      borderColor="lineColor"
      borderRadius="100%"
      color="lightGrey"
      fontSize="small"
      height={26}
      justifyContent="center"
      width={26}
    >
      {stepNumber}
    </Box>
  )
}

interface NavigationItemProps {
  body?: string,
  callbacks?: {
    onClick: () => void,
  },
  horizontal?: boolean,
  showTickIcon?: boolean,
  isActive?: boolean,
  isComplete?: boolean,
  isFirst?: boolean,
  isLast?: boolean,
  label: string,
  stepNumber: number,
}

const NavigationItem = (props: NavigationItemProps) => {
  const {
    body,
    callbacks,
    horizontal = false,
    showTickIcon = false,
    isActive = false,
    isComplete = false,
    isFirst = false,
    isLast = false,
    label,
    stepNumber,
  } = props

  const { onClick } = callbacks || {}

  const isIncomplete = !isComplete && !isActive
  const connectorBeforeColor = isActive || isComplete ? 'blue' : 'whiteGrey'
  const connectorAfterColor = isComplete ? 'blue' : 'whiteGrey'

  return (
    <Box
      borderColor="lineColor"
      onClick={onClick}
      position="relative"
      width={horizontal ? '100%' : 'auto'}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {horizontal ? (
        <Box alignItems="center" flexDirection="column" paddingY="large" width="100%">
          <Box alignItems="center" flexDirection="column" marginBottom="large" width="100%">
            <Text color={isIncomplete ? 'lightGrey' : 'bodyFontLightColor'} fontSize="small" textAlign="center" fontWeight={isActive ? 'bold' : 'normal'}>
              {label}
            </Text>
          </Box>

          <Box alignItems="center" flexDirection="row" flexShrink={0} height="26px" justifyContent="center" width="100%">
            <Box
              backgroundColor={isFirst ? null : connectorBeforeColor}
              height={2}
              width="calc((100% - 26px) / 2)"
            />

            {renderNumberCircleComponent({
              isActive,
              isComplete,
              showTickIcon,
              stepNumber,
            })}

            <Box
              backgroundColor={isLast ? null : connectorAfterColor}
              height={2}
              width="calc((100% - 26px) / 2)"
            />
          </Box>
        </Box>
      ) : (
        <>
          <Box
            alignItems="center"
            flexDirection="column"
            flexShrink={0}
            height="100%"
            justifyContent="center"
            marginLeft="large"
            width="26px"
          >
            <Box backgroundColor={isFirst ? null : connectorBeforeColor} height="calc((100% - 26px) / 2)" width={2} />

            {renderNumberCircleComponent({
              isActive,
              isComplete,
              showTickIcon,
              stepNumber,
            })}

            <Box backgroundColor={isLast ? null : connectorAfterColor} height="calc((100% - 26px) / 2)" width={2} />
          </Box>

          <Box flexDirection="column" marginLeft="large" paddingY="large" width="auto">
            <Text color={isIncomplete ? 'lightGrey' : 'bodyFontLightColor'} fontSize="xsmall">
              {label}
            </Text>
            <Text color={isIncomplete ? 'lightGrey' : 'bodyFontColor'} fontSize="small" marginTop="small">
              {body}
            </Text>
          </Box>
        </>
      )}
    </Box>
  )
}

export default NavigationItem
